export default __webpack_public_path__ + "assets/f419f49e28132406f2358efdda481c6a.png";